<template>
    <v-container fluid>
        <v-data-table v-model="selectedQuestions" class="elevation-2 table" hover item-value="id" show-select
            items-per-page-text="Itens por pagina" page-text="{0}-{1} de {2}" :headers="headers" :items="listQuestions"
            :loading="loading">
            <template v-slot:no-data>
                <v-alert class="my-4" :value="true">
                    <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                </v-alert>
            </template>
            <template v-slot:item.question="{ item }">
                <div v-html="sanitizeHtml(item.columns.question)" />
            </template>
            <template v-slot:item.difficulty="{ item }">
                <v-chip color="secondary" size="small" variant="tonal">
                    Nível {{ item.columns.difficulty }}
                </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon icon="mdi-delete" class="ma-2 pa-2" color="error" size="small" @click="askDeleteQuestion(item.raw)" />
            </template>
        </v-data-table>
        <v-card-actions class="ml-2 mt-4">
            <v-btn class="bg-primary" variant="flat" @click="createQuestions()">Criar Questionario</v-btn>
        </v-card-actions>
    </v-container>

    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-toolbar class="bg-primary-darken-1" elevation="1">
                <v-spacer />
                <v-icon color="warning" icon="mdi-alert" size="x-large" />
                <v-spacer />
            </v-toolbar>
            <v-card-title class="text-center">Digite o nome do questionario:</v-card-title>
            <v-form ref="form" @submit.prevent="onSubmit">
                <v-card-text>
                    <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
                    <v-text-field v-model="name" color="primary" label="Nome" :rules="requiredField" />
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn class="bg-primary" variant="flat" type="submit" :loading="loadingSave">Criar</v-btn>
                    <v-btn class="bg-primary" variant="flat" @click="closeDialog">Cancelar</v-btn>
                    <v-spacer />
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="560px">
        <v-card>
            <v-toolbar class="bg-primary-darken-1" elevation="1">
                <v-spacer />
                <v-icon color="warning" icon="mdi-alert" size="x-large" />
                <v-spacer />
            </v-toolbar>
            <v-card-title class="text-center">Remover esta questao apenas do repositorio?</v-card-title>
            <v-card-text class="text-center">
                A questao deixara de aparecer para reaproveitamento, mas os questionarios e as avaliacoes ja criadas continuarao intactos.
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="red" variant="flat" :loading="deletingRepositoryQuestion" @click="deleteRepositoryQuestionConfirm">Sim</v-btn>
                <v-btn class="bg-primary" variant="flat" @click="closeDelete">Cancelar</v-btn>
                <v-spacer />
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="sbColor">
        {{ sbMessage }}
        <template v-slot:actions>
            <v-btn @click="snackbar = false">
                Fechar
            </v-btn>
        </template>
    </v-snackbar>
</template>

<style type="text/css">
.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
    background-color: #16324A !important;
    color: white;
}

.v-data-table .v-table__wrapper>table>thead>tr>th.v-data-table__th--sortable:hover,
.v-data-table .v-table__wrapper>table tbody>tr>th.v-data-table__th--sortable:hover {
    color: white;
}
</style>

<script src="@/assets/js/repositorio.js" />
